import React, { useRef } from "react";
import { Stack, Button, Container } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import VideoTable from "../../component/VideoManagement/VideoTable";
import { strings } from "../../utils/constants";

/**
 * Video Management admin page.
 *
 * Layout mirrors the existing admin list pages (e.g. FormManagementPage /
 * CarrierManagementPage): controls sit inside a `container-wrapper` above the
 * shared `ftable`, so the header aligns with the table. The "Upload Video"
 * button opens the upload modal that lives inside VideoTable via a registered
 * trigger callback.
 */
export default function VideoManagementPage() {
  const uploadTriggerRef = useRef(null);

  const registerUploadTrigger = (fn) => {
    uploadTriggerRef.current = fn;
  };

  const handleUploadClick = () => {
    if (uploadTriggerRef.current) {
      uploadTriggerRef.current();
    }
  };

  return (
    <>
      <Container className="container-wrapper" style={{ marginBottom: "12px" }}>
        <Stack direction="column" alignItems="end">
          <Button
            variant="contained"
            className="fbutton"
            startIcon={<AddIcon />}
            onClick={handleUploadClick}
            sx={{ width: "auto !important", px: 2 }}
          >
            {strings.video.UPLOAD_VIDEO}
          </Button>
        </Stack>
      </Container>

      <VideoTable registerUploadTrigger={registerUploadTrigger} />
    </>
  );
}
